import { render, staticRenderFns } from "./RejectReason.vue?vue&type=template&id=399f5cae&scoped=true&"
import script from "./RejectReason.vue?vue&type=script&lang=js&"
export * from "./RejectReason.vue?vue&type=script&lang=js&"
import style0 from "./RejectReason.vue?vue&type=style&index=0&id=399f5cae&lang=less&scoped=true&"
import style1 from "./RejectReason.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f5cae",
  null
  
)

export default component.exports